var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-page" }, [
    _c("div", { staticClass: "login-left" }, [
      false
        ? _c("div", { staticClass: "left-version" }, [
            _c("span", [_vm._v(_vm._s(_vm.version))]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "Hblock" }, [_vm._v(" ")]),
      _c("div", { attrs: { tabindex: "0" } }, [
        _c("div", { staticClass: "left-name" }, [
          _vm._v(_vm._s(_vm.$tran("Lenovo"))),
        ]),
        _c("div", { staticClass: "left-subName" }, [
          _vm._v(_vm._s(_vm.$tran("Display Fleet Manager"))),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "login-block account-padding" }, [
      _c(
        "div",
        { staticClass: "login-account" },
        [
          _c(
            "cus-input",
            {
              staticClass: "login-animation1",
              attrs: {
                placeholder: _vm.$tran("Enter your account ID"),
                password: "",
              },
              on: { blur: _vm.validateAccount },
              model: {
                value: _vm.ruleForm.username,
                callback: function ($$v) {
                  _vm.$set(_vm.ruleForm, "username", $$v)
                },
                expression: "ruleForm.username",
              },
            },
            [
              _c("img", {
                attrs: {
                  slot: "prefix",
                  src: require("@/assets/login/password.png"),
                  alt: "",
                },
                slot: "prefix",
              }),
            ]
          ),
          _c(
            "cus-input",
            {
              staticClass: "login-animation2",
              attrs: {
                id: "loginPassword",
                type: _vm.passwordVisable ? "password" : "text",
                placeholder: _vm.$tran("Enter your password"),
                password: "",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.signIn.apply(null, arguments)
                },
              },
              model: {
                value: _vm.ruleForm.password,
                callback: function ($$v) {
                  _vm.$set(_vm.ruleForm, "password", $$v)
                },
                expression: "ruleForm.password",
              },
            },
            [
              _c("img", {
                attrs: {
                  slot: "prefix",
                  src: require("@/assets/login/account.png"),
                  alt: "",
                },
                slot: "prefix",
              }),
              _c("i", {
                class: _vm.passwordVisable ? "el-icon-lock" : "el-icon-unlock",
                attrs: { slot: "suffix" },
                on: {
                  click: function ($event) {
                    _vm.passwordVisable = !_vm.passwordVisable
                  },
                },
                slot: "suffix",
              }),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "login-btn login-animation3",
          attrs: { role: "button", tabindex: "0" },
          on: {
            click: _vm.signIn,
            keypress: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.signIn.apply(null, arguments)
            },
          },
        },
        [_c("span", [_vm._v(_vm._s(_vm.$tran("Log In")))])]
      ),
      _c("div", { staticClass: "login-desc login-animation4" }, [
        _c(
          "span",
          {
            attrs: { role: "button", tabindex: "0" },
            on: { click: _vm.resetPassword },
          },
          [_vm._v(_vm._s(_vm.$tran("Reset Password?")))]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }